import { CLINICAL_TRIAL_DESIGN_SUB_GROUP_SHELL_KEYS } from "@frontend/common";

type DefaultObjectType = {
  [key: string]: string;
};

export const SUB_GROUP_SHELL_TITLE: DefaultObjectType = {
  [CLINICAL_TRIAL_DESIGN_SUB_GROUP_SHELL_KEYS.arm]: "Arm",
};
